export const editIcon = (
    <svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 23.656 24.063">
        <g id="Group_1085" data-name="Group 1085" transform="translate(-1768.553 -47.392)">
            <g id="Group_1082" data-name="Group 1082" transform="translate(1623.554 -94.381)">
                <path
                    id="Path_1384"
                    data-name="Path 1384"
                    d="M164.446,153.417v11.919H145.5V144.477H159.46"
                    transform="translate(0)"
                    fill="none"
                    stroke="#000000"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1"
                />
            </g>
            <g id="Group_1080" data-name="Group 1080" transform="translate(1679.407 -46.539)">
                <path
                    id="Path_1383"
                    data-name="Path 1383"
                    d="M101.929,107.945l-4.1.962.962-4.1,9.894-9.9a1.27,1.27,0,0,1,1.794,0l1.346,1.346a1.27,1.27,0,0,1,0,1.794Z"
                    transform="translate(0 0)"
                    fill="#E4EAFF"
                    stroke="#000000"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1"
                />
                <line
                    id="Line_180"
                    data-name="Line 180"
                    x1="3.142"
                    y1="3.141"
                    transform="translate(108.236 95.359)"
                    fill="none"
                    stroke="#000000"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1"
                />
                <line
                    id="Line_181"
                    data-name="Line 181"
                    x1="3.134"
                    y1="3.149"
                    transform="translate(107.34 96.256)"
                    fill="none"
                    stroke="#000000"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1"
                />
                <line
                    id="Line_182"
                    data-name="Line 182"
                    x1="3.14"
                    y1="3.14"
                    transform="translate(98.95 104.646)"
                    fill="none"
                    stroke="#000000"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1"
                />
            </g>
        </g>
    </svg>
);
